// Common

export default class CampListSeparator extends React.Component {
  render() {
    return (
        <div className={'card card_big camp-list-separator'}
             title={this.props.title}
        >
          {this.props.text}
        </div>
    );
  }
}
